import { Text, View } from '@react-pdf/renderer';
import dayjs from 'dayjs';
import { getPreviousQuarter } from 'utils/helpers';

interface IPdfFooter {
  pageNumber: number;
  pagesCount: number;
}

export const PdfFooter = ({ pageNumber, pagesCount }: IPdfFooter) => {
  return (
    <View
      style={{
        position: 'absolute',
        bottom: 0,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '16px',
        width: '100%',
        height: '40px',
        paddingHorizontal: '20px',
        fontSize: '10px',
        color: '#5c5c5c',
        borderTop: '1px solid #F2F2F2'
      }}
    >
      <Text>
        Report Generated on {dayjs(new Date()).format('MMMM DD, YYYY')}
      </Text>

      <View
        style={{ width: '1px', height: '14px', backgroundColor: '#f2f2f2' }}
      />

      <Text>{`Data last refreshed as of ${getPreviousQuarter()}`}</Text>

      <View
        style={{ width: '1px', height: '14px', backgroundColor: '#f2f2f2' }}
      />

      <Text>
        Any questions? Contact{' '}
        <Text style={{ color: '#409958' }}>
          ICONIQGrowthInsights@iconiq.com
        </Text>
      </Text>

      <Text style={{ marginLeft: 'auto' }}>
        {pageNumber} of {pagesCount}
      </Text>
    </View>
  );
};
